import React, { useState, useEffect, useRef } from "react";
import "./providerPhotos.scss";
import PopupModal from "../../../common/PopupModal";
import CgCarousel from "../../../common/CgCarousel";
import ExamplePhoto from "../../../assets/images/exampleProfilePhoto.png";
import ImageUpload from "../../../common/ImageUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddProviderPhotos,
  fetchDeleteProviderPhotos,
  fetchProviderPhotosList,
  fetchProviderProfilePhoto,
} from "../../../store/ProviderInfo/ProviderPhotosActions";
import { fetchProviderInformation } from "../../../store/ProviderInfo/ProviderOverviewActions";
import { useLocation } from "react-router-dom";
import ProviderIconPNG from "../../../assets/Icons/provider-icon.png";
import uploadSampleFull from "../../../assets/Icons/upload-sample-full.jpg";

const PROVIDER_ICON = "PROVIDER_ICON";
const ProviderPhotos = ({
  providerId,
  openProviderPhotos = false,
  onlyPopup = false,
  closePopupCallback = () => {},
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmPhotoDelete, setConfirmPhotoDelete] = useState(false);
  const [showProfilePhoto, setShowProfilePhoto] = useState(false);
  const [popupState, setPopupState] = useState(""); // photos
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [carouselSelectedImg, setCarouselSelectedImg] = useState();
  const [rawUploadedFile, setRawUploadedFile] = useState(null);
  const [renderImage, setRenderImage] = useState(null);
  const [resetImgValue, setResetImgValue] = useState(false);
  const [viewMore, setViewMore] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState();
  const [showError, setShowError] = useState(false);
  const location = useLocation();
  const locationData = location.pathname.split("/");
  // const providerId = locationData[2];
  const [prvId, setPrvId] = useState(providerId ? providerId : locationData[2]);

  const dispatch = useDispatch();
  const { photosData } = useSelector((state) => state.providerPhotosList);
  const { profilePhotosLoading, profilePhto, profilePhotoError } = useSelector(
    (state) => state.providerProfilePhoto,
  );

  const { isDataLoading, providerOverviewData } = useSelector(
    (state) => state.providerOverviewInformation,
  );

  const dropdownRef = useRef(null);

  useEffect(() => {
    if (providerId) {
      setPrvId(providerId);
    } else {
      setPrvId(locationData[2]);
    }
  }, [providerId]);

  useEffect(() => {
    // console.log({ profilePhto });
    if (profilePhto?.image?.large) {
      setShowProfilePhoto(true);
      setRenderImage(profilePhto?.image?.large);
    } else {
      setShowProfilePhoto(false);
    }
  }, [profilePhto]);

  useEffect(() => {
    if (profilePhotoError) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  }, [profilePhotoError]);

  useEffect(() => {
    if (openProviderPhotos) {
      setOpenPopup(true);
      setPopupState("photos");
      setResetImgValue(false);
    }
  }, [openProviderPhotos]);

  useEffect(() => {
    dispatch(fetchProviderInformation(prvId));
    dispatch(fetchProviderPhotosList(prvId));
    dispatch(fetchProviderProfilePhoto(prvId));
  }, []);

  useEffect(() => {
    if (profilePhto?.image?.large) {
      setRenderImage(profilePhto?.image?.large);
    } else {
      setRenderImage(PROVIDER_ICON);
    }
  }, [profilePhto]);

  const fetchHandleFileUplaod = (formData) => {
    dispatch(
      fetchAddProviderPhotos({ providerId: prvId, data: formData }),
    ).then(() => {
      dispatch(fetchProviderPhotosList(prvId));
      dispatch(fetchProviderProfilePhoto(prvId));
    });
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handlePencilClick = () => {
    setIsDropdownVisible(true);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleProviderPhotoDelete = () => {
    setRenderImage(PROVIDER_ICON);
    setShowProfilePhoto(!showProfilePhoto);
    setConfirmPhotoDelete(!confirmPhotoDelete);
    // this will be an api call to remove photo
    // console.log("deleteItem", deleteItem);

    dispatch(
      fetchDeleteProviderPhotos({ providerId: prvId, imageId: deleteItem }),
    ).then(() => {
      dispatch(fetchProviderPhotosList(prvId));
    });
  };

  const handleOnDeletePhoto = () => {
    dispatch(
      fetchDeleteProviderPhotos({
        providerId: prvId,
        imageId: deleteItem.displayId,
      }),
    ).then(() => {
      dispatch(fetchProviderPhotosList(prvId));
    });
    setShowConfirmModal(!showConfirmModal);
  };

  const RenderProfileImage = () => {
    if (profilePhotosLoading) return <div> Loading .... </div>;

    return (
      <div
        className="img-bg border"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {showProfilePhoto && (
          <img
            className="showImg"
            alt="Profile Photo"
            height="145px"
            width="145px"
            src={renderImage === PROVIDER_ICON ? ProviderIconPNG : renderImage}
          />
        )}
        {!showProfilePhoto && (
          <div
            className="addImgWrapper"
            onClick={() => {
              setOpenPopup(true);
              setPopupState("photos");
              setResetImgValue(false);
            }}
          >
            <img
              className="noImg"
              style={{ backgroundColor: "transparent" }}
              alt="photo"
              height="80px"
              width="80px"
              src={ProviderIconPNG}
            />
            <div className="btnText"> + Add Photo </div>
          </div>
        )}
        <div ref={dropdownRef}>
          {!confirmPhotoDelete && isHovered && (
            <button
              type="button"
              className="pencil-icon"
              onClick={handlePencilClick}
            >
              {!confirmPhotoDelete && showProfilePhoto && (
                <i className="bi bi-pencil-fill"></i>
              )}
            </button>
          )}
          {isDropdownVisible && (
            <div className="img-update-deletedropdown">
              <div className="dropdown-menu show">
                <button
                  className="dropdown-item dropdown-item-divider"
                  onClick={() => {
                    setOpenPopup(true);
                    setPopupState("photos");
                    setResetImgValue(false);
                  }}
                >
                  Update
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => {
                    setConfirmPhotoDelete(!confirmPhotoDelete);
                    setIsDropdownVisible(!isDropdownVisible);
                    setDeleteItem(profilePhto?.displayId);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          )}
        </div>
        {confirmPhotoDelete && RenderConfirmPhotoDeleteModal()}
      </div>
    );
  };

  const RenderUploadImageJsx = () => {
    return (
      <div className="imgUplodWrapper">
        <div className="imgUpload">
          <img src={ProviderIconPNG} alt="" height="50px" width="50px" />
          <div className="inputFieldText">
            <div className="text-center">
              Drag photo here or
              <span className="linkColor"> browse </span>
              to upload a new photo
            </div>
            <p className="supportedFileText">
              Supported file types: .png, .gif, .jpg, .jpeg
            </p>
          </div>
        </div>
      </div>
    );
  };

  const RenderPhotosEditPopup = () => {
    if (popupState === "overview") return null;

    const RenderPhotos = () => {
      return (
        <div className="photosWrapper">
          <div className="photosSectionWrapper1">
            <div className="instructionImgWrapper">
              <img alt="hover img" src={ExamplePhoto} />
            </div>
            <div className="instructionListWrapper">
              <div>
                <h6 className="instructionHeader">
                  How to select a good profile photo
                </h6>
                <div className="instructionLines">
                  - Use a photo of the provider looking at the camera
                </div>
                <div className="instructionLines">
                  - Crop away any unnecessary background that makes the photo
                  look busy
                </div>
                <div className="instructionLines">
                  - Make sure the provider is smiling and looks professional
                </div>
              </div>
            </div>
          </div>
          <div className="photosSectionWrapper2">
            <ImageUpload
              resetValue={resetImgValue}
              key={selectedPhoto}
              renderCustom={RenderUploadImageJsx}
              isRenderCustom
              uploadedImage={selectedPhoto}
              onCropComplete={(res, url) => {
                setCarouselSelectedImg(url)
              }}
              handleGetFormData={(res) => {
                // console.log({ res });
                setRawUploadedFile(res);
              }}
              fileUploaded={(res) => {
                setCarouselSelectedImg(res)
              }}
            />
            {!onlyPopup && (
              <div className="carouselWrapper">
                <CgCarousel
                  images={Object.values(photosData ?? {}).map(
                    (photo) => photo.image.medium,
                  )}
                  selectedPhoto={async (img) => {
                    const response = await fetch(img);
                    const blob = await response.blob();
                    const file = new File([blob], "image.jpg", {
                      type: blob.type,
                    });
                    const formData = new FormData();
                    formData.append("file", file);
                    setRawUploadedFile(file);
                    setSelectedPhoto(img);
                    setCarouselSelectedImg(img);
                  }}
                />
              </div>
            )}
            <div className="photosBtnWrapper">
              <button
                className="saveBtn"
                onClick={() => {
                  const formData = new FormData();
                  formData.append("file", rawUploadedFile);
                  fetchHandleFileUplaod(formData);
                  setOpenPopup(!openPopup);
                  setRenderImage(carouselSelectedImg);
                  setSelectedPhoto("");
                  setShowProfilePhoto(true);
                  closePopupCallback();
                }}
              >
                SAVE PROFILE PHOTO
              </button>
              <button
                className="cancelBtn"
                onClick={() => {
                  setOpenPopup(false);
                  setPopupState("");
                  setResetImgValue(true);
                  closePopupCallback();
                }}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="photosEditWrapper">
        <PopupModal
          customRender={RenderPhotos}
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setPopupState("");
            closePopupCallback();
          }}
          onSave={() => {
            setOpenPopup(!openPopup);
            setPopupState("");
            closePopupCallback();
          }}
          popupHeading="UPDATE PROFILE PHOTO"
        />
      </div>
    );
  };

  const RenderConfirmPhotoDeleteModal = () => {
    return (
      <div className="confirmDeleteBtnWrapper">
        <div className="confirmText"> Delete Photo ? </div>
        <div
          className="yesBt"
          onClick={() => {
            handleProviderPhotoDelete();
          }}
        >
          YES
        </div>
        <div
          className="noBtn"
          onClick={() => {
            setConfirmPhotoDelete(!confirmPhotoDelete);
          }}
        >
          NO
        </div>
      </div>
    );
  };

  const RenderConfirmDeletePhotoModal = () => {
    return (
      <div className="confirmPhotoDeleteBtnWrapper">
        <div className="confirmText"> Delete Photo ? </div>
        <div className="confirmBtns">
          <div
            className="yesBt"
            onClick={() => {
              handleOnDeletePhoto();
            }}
          >
            YES
          </div>
          <div
            className="noBtn"
            onClick={() => {
              setShowConfirmModal(!showConfirmModal);
            }}
          >
            NO
          </div>
        </div>
      </div>
    );
  };

  const RenderAllProviderPhotos = () => {
    if (photosData.length < 1)
      return (
        <div
          className="noDataFound"
          style={{ width: "100%", marginRight: "20px", marginBottom: "20px" }}
        >
          No photos uploaded for this provider
        </div>
      );
    return (
      <div className="allPhotosListWrapper">
        {photosData
          ?.slice(0, viewMore ? 4 : photosData?.length)
          .map((photosItem, index) => (
            <div
              className="photosImg position-relative d-inline-block"
              key={index}
            >
              {photosItem.displayId === deleteItem?.displayId
                ? showConfirmModal && RenderConfirmDeletePhotoModal()
                : ""}
              <div className="imgBg">
                <img
                  alt={`Gallary Photo ${index + 1}`}
                  width="128px"
                  height="128px"
                  src={photosItem?.image?.small}
                  className="photoImage"
                />
              </div>
              <i
                className="bi bi-trash IcondeleteIcon position-absolute"
                onClick={() => {
                  setShowConfirmModal(true);
                  setDeleteItem(photosItem);
                  // console.log({ photosItem });
                }}
              ></i>
            </div>
          ))}
      </div>
    );
  };

  const RenderErrors = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong. Please check and try again.
      </div>
    );
  };

  return (
    <>
      {RenderErrors()}
      {!onlyPopup && (
        <div className="providerPhotosWrapper">
          <div className="providerPhotosDetails">
            <div className="photosDetailsWrapper">
              <div className="profileHeader"> PROFILE IMAGE </div>
              <div className="profileDesc">
                This is how patients see you when they visit your profile page
              </div>
              <div>{RenderProfileImage()}</div>
              {RenderPhotosEditPopup()}
            </div>
            <div className="otherPhotosWrapper">
              {isDataLoading ? (
                <div> Loading ..... </div>
              ) : (
                <div className="profileHeader">
                  PHOTOS OF DR. {providerOverviewData?.lastName}
                </div>
              )}
              <div className="profileDesc">
                Photos of you that are included in your profile gallery.
              </div>
              <div className="someOfProvoderPhotosWrapper">
                {RenderAllProviderPhotos()}
                {photosData?.length > 4 && (
                  <>
                    {viewMore && (
                      <div
                        className="viewMoreLessBtn"
                        onClick={() => {
                          setViewMore(!viewMore);
                        }}
                      >
                        VIEW MORE
                        <span>
                          <i className="bi bi-chevron-down"></i>
                        </span>
                      </div>
                    )}
                    {!viewMore && (
                      <div
                        className="viewMoreLessBtn"
                        onClick={() => {
                          setViewMore(!viewMore);
                        }}
                      >
                        VIEW LESS
                        <span>
                          <i className="bi bi-chevron-up"></i>
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="phtoTipsWrapper">
            <div className="profileHeader">
              <span>PHOTO TIPS</span>
              <div className="hrLine" />
            </div>
            <div className="profileDesc"> Examples of great photos </div>
            <div className="guidelinesPhotosWrapper">
              <img height="70" alt="" src={uploadSampleFull} />
            </div>
            <div className="providerPhotoGuideLinesWrapper">
              <div className="guideLinesItem">
                Confident provider smiling at the camera
              </div>
              <div className="guideLinesItem">Provider with staff members</div>
              <div className="guideLinesItem">
                Provider posing in an operatory
              </div>
            </div>
          </div>
        </div>
      )}
      {onlyPopup && RenderPhotosEditPopup()}
    </>
  );
};

export default ProviderPhotos;
